import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { handlerMapListCard } from "../card-utils/card-utils";
import {
  fetchCardDetailService,
  fetchCardListService,
  fetchCardActivateService,
  fetchCardUpdateStatusService,
  fetchCardUpdateEComStatusService,
  fetchCardShowFullNumService,
  fetchCardStatementService,
  fetchCardPhysicalRegisterService,
  fetchCardAuthorizationService,
  fetchCardHistoryService,
} from "../services/card.service";
import {
  fetchCardActivateFailure,
  fetchCardActivateSuccess,
  fetchCardAuthorizationFailure,
  fetchCardAuthorizationSuccess,
  fetchCardDetailFailure,
  fetchCardDetailSuccess,
  fetchCardFullNumFailure,
  fetchCardFullNumSuccess,
  fetchCardHistoryFailure,
  fetchCardHistorySuccess,
  fetchCardListFailure,
  fetchCardListSuccess,
  fetchCardPhysicalRegisterFailure,
  fetchCardPhysicalRegisterSuccess,
  fetchCardStatementFailure,
  fetchCardStatementSuccess,
  fetchCardUpdateEComStatusFailure,
  fetchCardUpdateEComStatusSuccess,
  fetchCardUpdateStatusFailure,
  fetchCardUpdateStatusSuccess,
} from "./actions";
import {
  FETCH_CARD_ACTIVATE_REQUEST,
  FETCH_CARD_DETAIL_REQUEST,
  FETCH_CARD_FULL_NUMBER_REQUEST,
  FETCH_CARD_LIST_REQUEST,
  FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST,
  FETCH_CARD_LOCK_UNLOCK_REQUEST,
  FETCH_CARD_PHYSICAL_REGISTER_REQUEST,
  FETCH_CARD_STATEMENT_REQUEST,
  FETCH_CARD_AUTHORIZATION_KEY_REQUEST,
  FETCH_CARD_HISTORY_REQUEST,
} from "./actions.type";
import {
  FetchCardActivateRequest,
  FetchCardAuthorizationRequest,
  FetchCardDetailRequest,
  FetchCardFullNumRequest,
  FetchCardHistoryRequest,
  FetchCardListRequest,
  FetchCardPhysicalRegisterRequest,
  FetchCardStatementRequest,
  FetchCardUpdateEComStatusRequest,
  FetchCardUpdateStatusRequest,
} from "./types";

function* fetchCardListSaga(action: FetchCardListRequest) {
  try {
    if (action.showLoading) yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardListService(action?.payload));
    console.log("fetchCardList response: ", response);
    if (action.showLoading) yield put(hideModal());
    if (response.status === 200) {
      const data = handlerMapListCard(response?.data?.listCards);
      yield put(fetchCardListSuccess(data));
    }
  } catch (e: any | AxiosError) {
    if (action.showLoading) yield put(hideModal());
    yield put(fetchCardListFailure());
    getErrorMessage(e, true);
  }
}

function* fetchCardDetailSaga(action: FetchCardDetailRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardDetailService(action?.payload));
    console.log("fetchCardDetail response: ", response);
    if (response.status === 200) {
      yield put(fetchCardDetailSuccess(response.data.card));
    }
  } catch (e: any | AxiosError) {
    yield put(fetchCardDetailFailure());
    getErrorMessage(e, true);
  }
}

function* fetchCardActivateSaga(action: FetchCardActivateRequest) {
  try {
    // yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardActivateService(action?.payload));
    console.log("fetchCardList response: ", response);
    // yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardActivateSuccess(response.data.verification));
    }
  } catch (e: any | AxiosError) {
    // yield put(hideModal());
    const errorMsg =
      e?.response?.data?.errorKey && e?.response?.data?.errorKey === "326" ? e?.response?.data?.errorKey : e?.response?.data?.title;
    yield put(fetchCardActivateFailure(errorMsg));
    getErrorMessage(e, false);
  }
}

function* fetchCardUpdateStatusSaga(action: FetchCardUpdateStatusRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardUpdateStatusService(action));
    console.log("fetchCardList response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardUpdateStatusSuccess(response.data.verification));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchCardUpdateStatusFailure());
    getErrorMessage(e, true);
  }
}

function* fetchCardUpdateEComStatusSaga(action: FetchCardUpdateEComStatusRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardUpdateEComStatusService(action));
    console.log("fetchCardList response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardUpdateEComStatusSuccess(response.data.verification));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchCardUpdateEComStatusFailure());
    getErrorMessage(e, true);
  }
}

function* fetchCardShowFullNumSaga(action: FetchCardFullNumRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardShowFullNumService(action?.payload));
    console.log("fetchCardList response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardFullNumSuccess(response.data.verification));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchCardFullNumFailure());
    getErrorMessage(e, true);
  }
}

function* fetchCardHistorySaga(action: FetchCardHistoryRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardHistoryService(action));
    console.log("fetchCardList response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardHistorySuccess(response.data.items));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchCardHistoryFailure());
    getErrorMessage(e, true);
  }
}

function* fetchCardStatementSaga(action: FetchCardStatementRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardStatementService(action));
    console.log("fetchCardList response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardStatementSuccess(response.data.listInVoid));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchCardStatementFailure());
    getErrorMessage(e, true);
  }
}

function* fetchCardPhysicalRegisterSaga(action: FetchCardPhysicalRegisterRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardPhysicalRegisterService(action));
    console.log("fetchCardList response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardPhysicalRegisterSuccess(response.data.listCards));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchCardPhysicalRegisterFailure(msg));
  }
}

function* fetchCardAuthorizationSaga(action: FetchCardAuthorizationRequest) {
  try {
    if (action.showLoading) yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchCardAuthorizationService(action));
    console.log("fetchCardList response: ", response);
    if (action.showLoading) yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchCardAuthorizationSuccess(response.data));
    }
  } catch (e: any | AxiosError) {
    if (action.showLoading) yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchCardAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* cardSaga() {
  yield all([
    takeLatest(FETCH_CARD_LIST_REQUEST, fetchCardListSaga),
    takeLatest(FETCH_CARD_DETAIL_REQUEST, fetchCardDetailSaga),
    takeLatest(FETCH_CARD_ACTIVATE_REQUEST, fetchCardActivateSaga),
    takeLatest(FETCH_CARD_LOCK_UNLOCK_REQUEST, fetchCardUpdateStatusSaga),
    takeLatest(FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST, fetchCardUpdateEComStatusSaga),
    takeLatest(FETCH_CARD_FULL_NUMBER_REQUEST, fetchCardShowFullNumSaga),
    takeLatest(FETCH_CARD_HISTORY_REQUEST, fetchCardHistorySaga),
    takeLatest(FETCH_CARD_STATEMENT_REQUEST, fetchCardStatementSaga),
    takeLatest(FETCH_CARD_PHYSICAL_REGISTER_REQUEST, fetchCardPhysicalRegisterSaga),
    takeLatest(FETCH_CARD_AUTHORIZATION_KEY_REQUEST, fetchCardAuthorizationSaga),
  ]);
}

export default cardSaga;
